
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.11.1
 * Query Engine version: 2b0c12756921c891fec4f68d9444e18c7d5d4a6a
 */
Prisma.prismaVersion = {
  client: "3.11.1",
  engine: "2b0c12756921c891fec4f68d9444e18c7d5d4a6a"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  auth0Id: 'auth0Id',
  email: 'email',
  createdAt: 'createdAt',
  lastLoginAt: 'lastLoginAt',
  disabledAt: 'disabledAt',
  deletedAt: 'deletedAt',
  roles: 'roles'
});

exports.Prisma.UserProfileScalarFieldEnum = makeEnum({
  id: 'id',
  handle: 'handle',
  name: 'name',
  bio: 'bio',
  isAvailableToWork: 'isAvailableToWork',
  userId: 'userId'
});

exports.Prisma.ThreadScalarFieldEnum = makeEnum({
  id: 'id'
});

exports.Prisma.MessageScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  text: 'text',
  userId: 'userId',
  threadId: 'threadId'
});

exports.Prisma.JobPostScalarFieldEnum = makeEnum({
  id: 'id',
  shortId: 'shortId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  paymentCreatedAt: 'paymentCreatedAt',
  paymentCapturedAt: 'paymentCapturedAt',
  requestedApprovalAt: 'requestedApprovalAt',
  approvedAt: 'approvedAt',
  stoppedAt: 'stoppedAt',
  originType: 'originType',
  wasCreatedSessionless: 'wasCreatedSessionless',
  qualityScore: 'qualityScore',
  qualityScoreOverride: 'qualityScoreOverride',
  publishStartsAt: 'publishStartsAt',
  publishExpiresAt: 'publishExpiresAt',
  publishHistory: 'publishHistory',
  isSticky: 'isSticky',
  title: 'title',
  description: 'description',
  scraperAssignedTags: 'scraperAssignedTags',
  taggerRejectedTags: 'taggerRejectedTags',
  taggerAssignedTags: 'taggerAssignedTags',
  userRejectedTags: 'userRejectedTags',
  userAssignedTags: 'userAssignedTags',
  applyType: 'applyType',
  applyUrl: 'applyUrl',
  hasCompensation: 'hasCompensation',
  hasHiringOrganisation: 'hasHiringOrganisation',
  hasSourcingOrganisation: 'hasSourcingOrganisation',
  hasLocations: 'hasLocations',
  hasRemote: 'hasRemote',
  userId: 'userId',
  hiringOrganisationId: 'hiringOrganisationId',
  sourcingOrganisationId: 'sourcingOrganisationId'
});

exports.Prisma.AccessCodeScalarFieldEnum = makeEnum({
  id: 'id',
  jobPostId: 'jobPostId'
});

exports.Prisma.CompensationScalarFieldEnum = makeEnum({
  id: 'id',
  currency: 'currency',
  unit: 'unit',
  min: 'min',
  max: 'max',
  extras: 'extras',
  raw: 'raw',
  jobPostId: 'jobPostId'
});

exports.Prisma.ExtrasScalarFieldEnum = makeEnum({
  id: 'id',
  providesVisaSponsorship: 'providesVisaSponsorship',
  providesPaidRelocation: 'providesPaidRelocation',
  jobPostId: 'jobPostId'
});

exports.Prisma.OrganisationScalarFieldEnum = makeEnum({
  id: 'id',
  slug: 'slug',
  webUrl: 'webUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  about: 'about',
  aboutLong: 'aboutLong',
  size: 'size',
  careersUrl: 'careersUrl',
  twitterUrl: 'twitterUrl',
  twitterFollowersCount: 'twitterFollowersCount',
  linkedinUrl: 'linkedinUrl',
  githubUrl: 'githubUrl',
  instagramUrl: 'instagramUrl',
  youtubeUrl: 'youtubeUrl',
  favicon: 'favicon',
  logo: 'logo',
  rank: 'rank',
  scraperAssignedTags: 'scraperAssignedTags',
  taggerRejectedTags: 'taggerRejectedTags',
  taggerAssignedTags: 'taggerAssignedTags',
  userRejectedTags: 'userRejectedTags',
  userAssignedTags: 'userAssignedTags',
  userId: 'userId'
});

exports.Prisma.LocationScalarFieldEnum = makeEnum({
  id: 'id',
  order: 'order',
  address: 'address',
  formattedAddress: 'formattedAddress',
  results: 'results',
  latitude: 'latitude',
  longitude: 'longitude',
  jobPostId: 'jobPostId'
});

exports.Prisma.RemoteScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  regions: 'regions',
  jobPostId: 'jobPostId'
});

exports.Prisma.JobPostTweetScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  message: 'message',
  jobPostId: 'jobPostId'
});

exports.Prisma.JobPostAnalyticsScalarFieldEnum = makeEnum({
  id: 'id',
  updatedAt: 'updatedAt',
  impressionsByDate: 'impressionsByDate',
  impressions: 'impressions',
  detailViewsByDate: 'detailViewsByDate',
  detailViews: 'detailViews',
  applyClicksByDate: 'applyClicksByDate',
  applyClicks: 'applyClicks',
  jobPostId: 'jobPostId'
});

exports.Prisma.ActivityLogScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  type: 'type',
  message: 'message',
  data: 'data',
  errors: 'errors',
  actorId: 'actorId',
  observerId: 'observerId',
  jobPostId: 'jobPostId',
  orderId: 'orderId',
  organisationId: 'organisationId'
});

exports.Prisma.OrderScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  checkoutSessionId: 'checkoutSessionId',
  paymentIntentId: 'paymentIntentId',
  jobPostId: 'jobPostId'
});

exports.Prisma.OrderItemScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  startsAt: 'startsAt',
  expiresAt: 'expiresAt',
  disabledAt: 'disabledAt',
  priceAmount: 'priceAmount',
  skuId: 'skuId',
  orderId: 'orderId',
  jobPostId: 'jobPostId'
});

exports.Prisma.SkuScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  name: 'name',
  description: 'description',
  priceAmount: 'priceAmount',
  maxLimitPerJobPost: 'maxLimitPerJobPost',
  isRequiredForJobPost: 'isRequiredForJobPost',
  customProperties: 'customProperties',
  sortOrder: 'sortOrder'
});

exports.Prisma.CheckoutSessionScalarFieldEnum = makeEnum({
  id: 'id',
  updatedAt: 'updatedAt',
  data: 'data'
});

exports.Prisma.PaymentIntentScalarFieldEnum = makeEnum({
  id: 'id',
  updatedAt: 'updatedAt',
  data: 'data'
});

exports.Prisma.InvoiceScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  downloadedAt: 'downloadedAt',
  emailedAt: 'emailedAt',
  data: 'data',
  orderId: 'orderId'
});

exports.Prisma.GeocodeCacheScalarFieldEnum = makeEnum({
  address: 'address',
  status: 'status',
  results: 'results',
  latitude: 'latitude',
  longitude: 'longitude'
});

exports.Prisma.KeyValueScalarFieldEnum = makeEnum({
  key: 'key',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  value: 'value'
});

exports.Prisma.TriggerScalarFieldEnum = makeEnum({
  id: 'id',
  isActive: 'isActive',
  nextAfter: 'nextAfter',
  displayOrder: 'displayOrder'
});

exports.Prisma.ScrapedJobPostScalarFieldEnum = makeEnum({
  id: 'id',
  url: 'url',
  applyUrl: 'applyUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fetchedAt: 'fetchedAt',
  parsedAt: 'parsedAt',
  content: 'content',
  parsed: 'parsed',
  jobPostId: 'jobPostId'
});

exports.Prisma.CrawlScriptScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isActive: 'isActive',
  nextAfter: 'nextAfter',
  periodInMinutes: 'periodInMinutes',
  periodRandomness: 'periodRandomness',
  domain: 'domain'
});

exports.Prisma.WorkerTaskScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  runAfter: 'runAfter',
  prioritizedAt: 'prioritizedAt',
  assignedAt: 'assignedAt',
  type: 'type',
  status: 'status',
  worker: 'worker',
  logs: 'logs',
  domainThrottleId: 'domainThrottleId',
  crawlScriptId: 'crawlScriptId'
});

exports.Prisma.DomainThrottleScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isBlocked: 'isBlocked',
  lastAt: 'lastAt',
  nextAfter: 'nextAfter',
  periodInMinutes: 'periodInMinutes',
  periodRandomness: 'periodRandomness'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.JsonNullValueInput = makeEnum({
  JsonNull: 'JsonNull'
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull',
  AnyNull: 'AnyNull'
});
exports.UserRole = makeEnum({
  ADMIN: 'ADMIN',
  SERVICE: 'SERVICE'
});

exports.JobPostOriginType = makeEnum({
  POSTED: 'POSTED',
  SCRAPED: 'SCRAPED',
  SCRAPED_CHROME_EXTENSION: 'SCRAPED_CHROME_EXTENSION'
});

exports.JobPostApplyType = makeEnum({
  VIA_JOBSINJS: 'VIA_JOBSINJS',
  REDIRECT_TO_URL: 'REDIRECT_TO_URL'
});

exports.CurrencyCode = makeEnum({
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BTC: 'BTC',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLF: 'CLF',
  CLP: 'CLP',
  CNH: 'CNH',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUC: 'CUC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GEL: 'GEL',
  GGP: 'GGP',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  IMP: 'IMP',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JEP: 'JEP',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KPW: 'KPW',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRU: 'MRU',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLL: 'SLL',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STD: 'STD',
  STN: 'STN',
  SVC: 'SVC',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VEF: 'VEF',
  VES: 'VES',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XAG: 'XAG',
  XAU: 'XAU',
  XCD: 'XCD',
  XDR: 'XDR',
  XOF: 'XOF',
  XPD: 'XPD',
  XPF: 'XPF',
  XPT: 'XPT',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW',
  ZWL: 'ZWL'
});

exports.CompensationUnit = makeEnum({
  HOUR: 'HOUR',
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR'
});

exports.OrganisationSize = makeEnum({
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
  H: 'H',
  I: 'I'
});

exports.JobPostRemoteType = makeEnum({
  NONE: 'NONE',
  GENERAL: 'GENERAL',
  WORLDWIDE: 'WORLDWIDE',
  SELECTED_REGIONS: 'SELECTED_REGIONS'
});

exports.ActivityLogType = makeEnum({
  USER__CREATED: 'USER__CREATED',
  USER__AUTHENTICATED: 'USER__AUTHENTICATED',
  USER__SOFT_DELETED: 'USER__SOFT_DELETED',
  JOB_POST__CREATED: 'JOB_POST__CREATED',
  JOB_POST__UPDATED: 'JOB_POST__UPDATED',
  JOB_POST__SET_META: 'JOB_POST__SET_META',
  JOB_POST__SET_HIRING_ORGANISATION: 'JOB_POST__SET_HIRING_ORGANISATION',
  JOB_POST__SET_SOURCING_ORGANISATION: 'JOB_POST__SET_SOURCING_ORGANISATION',
  JOB_POST__CHANGED_OWNER: 'JOB_POST__CHANGED_OWNER',
  JOB_POST__INDEXED: 'JOB_POST__INDEXED',
  JOB_POST__UNINDEXED: 'JOB_POST__UNINDEXED',
  JOB_POST__APPROVED: 'JOB_POST__APPROVED',
  JOB_POST__STOPPED: 'JOB_POST__STOPPED',
  JOB_POST__RESUMED: 'JOB_POST__RESUMED',
  JOB_POST__DELETED: 'JOB_POST__DELETED',
  ORGANISATION__UPSERTED: 'ORGANISATION__UPSERTED',
  ORGANISATION__DELETED: 'ORGANISATION__DELETED',
  ORDER__CREATED: 'ORDER__CREATED',
  ORDER__PAID: 'ORDER__PAID',
  ORDER__PAYMENT_CAPTURED: 'ORDER__PAYMENT_CAPTURED',
  ORDER__PAYMENT_CANCELLED: 'ORDER__PAYMENT_CANCELLED',
  ORDER__INVOICE_CREATED: 'ORDER__INVOICE_CREATED',
  ORDER__INVOICE_EMAILED: 'ORDER__INVOICE_EMAILED',
  ORDER__INVOICE_DOWNLOADED: 'ORDER__INVOICE_DOWNLOADED',
  TWITTER__JOB_POST_TWEETED: 'TWITTER__JOB_POST_TWEETED'
});

exports.SkuType = makeEnum({
  JOB_POST_PUBLISH: 'JOB_POST_PUBLISH',
  JOB_POST_PUBLISH_EXTENSION: 'JOB_POST_PUBLISH_EXTENSION',
  JOB_POST_STICKY: 'JOB_POST_STICKY',
  JOB_POST_THREE_TWEETS: 'JOB_POST_THREE_TWEETS',
  JOB_POST_BOOST_VISIBILITY: 'JOB_POST_BOOST_VISIBILITY'
});

exports.WorkerTaskType = makeEnum({
  CRAWL: 'CRAWL',
  FETCH: 'FETCH'
});

exports.WorkerTaskStatus = makeEnum({
  QUEUED: 'QUEUED',
  ASSIGNED: 'ASSIGNED',
  FAILED: 'FAILED',
  SUCCEEDED: 'SUCCEEDED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  UserProfile: 'UserProfile',
  Thread: 'Thread',
  Message: 'Message',
  JobPost: 'JobPost',
  AccessCode: 'AccessCode',
  Compensation: 'Compensation',
  Extras: 'Extras',
  Organisation: 'Organisation',
  Location: 'Location',
  Remote: 'Remote',
  JobPostTweet: 'JobPostTweet',
  JobPostAnalytics: 'JobPostAnalytics',
  ActivityLog: 'ActivityLog',
  Order: 'Order',
  OrderItem: 'OrderItem',
  Sku: 'Sku',
  CheckoutSession: 'CheckoutSession',
  PaymentIntent: 'PaymentIntent',
  Invoice: 'Invoice',
  GeocodeCache: 'GeocodeCache',
  KeyValue: 'KeyValue',
  Trigger: 'Trigger',
  ScrapedJobPost: 'ScrapedJobPost',
  CrawlScript: 'CrawlScript',
  WorkerTask: 'WorkerTask',
  DomainThrottle: 'DomainThrottle'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
